import styles from './Register.module.css'
import {Input} from "antd";
import {useEffect, useState} from "react";
import {LGBTButton} from "../../components/lgbtButton/LGBTButton";
import {useNavigate} from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchError, register } from '../../store/app-slice/AppSlice';
import { Modal } from '../../components/modal/Modal';
import { Rules } from './components/rules/Rules';
import { userLogin } from '../../models/commonModels';
import { Checkbox } from 'antd';
export const RegisterPage = () =>{
    const navigation = useNavigate();
    const [name,setName] = useState("");
    const [surname,setSurname]=useState("");
    const [userEmail,setUserEmail] = useState("");
    const [userPass,setUserPass] = useState("")
    const [userPassTest,setUserPassTest] = useState("")
    const dispatch:any = useAppDispatch();
    const error = useAppSelector(state=>state.appStore.error)
    const [isRules,setIsRules] = useState(false)
    const [isCheck,setIsCheck] = useState(false)
    useEffect(()=>{
       if(error==="Регистрация прошла успешно!!!") {
            //navigation("auth")
            const user:userLogin = {email:userEmail,pswd:userPass}
            localStorage.setItem("currentUser",JSON.stringify(user));
            navigation("*")
       }
    },[error])

    const registerAction = ()=>{
        if(userPass!=userPassTest){
            dispatch(fetchError("Пароли не совпадают"))
            return;
        }
        dispatch(register({email:userEmail,pswd:userPass,f_name:name,s_name:surname,p_name:"" }))
    }
    return(
        <div className={styles.register_content}>
            <Input
                placeholder={"Имя"}
                onChange={(e)=>setName(e.target.value)}
                value={name} />
            <Input
                placeholder={"Фамилия"}
                onChange={(e)=>setSurname(e.target.value)}
                value={surname} />
            <Input
                placeholder={"Ваша почта (обязательное поле)"}
                onChange={(e)=>setUserEmail(e.target.value)}
                value={userEmail} />
            <Input.Password
                placeholder={"Ваш пароль (минимум 8 символов)"}
                onChange={(e)=>setUserPass(e.target.value)}
                value={userPass} />
            <Input.Password
                placeholder={"Введите пароль еще раз"}
                onChange={(e)=>setUserPassTest(e.target.value)}
                value={userPassTest} />
            {!isCheck&&<LGBTButton
                colors={["gray","gray"]}
                text={"ЗАРЕГИСТРИРОВАТЬСЯ"}
                textSize={"16px"}
                textColor={"white"}
                onClick={()=>{}}/>}
            {isCheck&&<LGBTButton
                colors={["#F6503C","#E8AA18","#96C833","#318FC2","#10406E"]}
                text={"ЗАРЕГИСТРИРОВАТЬСЯ"}
                textSize={"16px"}
                textColor={"white"}
                onClick={()=>{registerAction()}}/>}
            <div className={styles.register_green} onClick={()=>setIsRules(true)}>
                Правила участия
            </div>
            <div className={styles.register_polici_container}>
                <Checkbox checked={isCheck} onChange={()=>{setIsCheck(!isCheck)}}></Checkbox>
                <div>
                    Пользователь выражает свое согласие на обработку своих персональных данных при предоставлении соответствующих сведений и осознанно соглашается на такую обработку, признавая свою осведомленность относительно цели обработки данных. Целью сбора и обработки персональных данных является обеспечение надлежащего функционирования сайта/сервиса, оказание качественных услуг пользователю, выполнение обязательств перед пользователями и улучшение качества обслуживания пользователей.
                </div>
            </div>
            <Modal isOpen={isRules}>
                <Modal.Content isClosable={true} onClose={()=>setIsRules(false)} >
                    <Rules/>
                </Modal.Content>
            </Modal>
        </div>
    )
}